import { arrayFromEnumValues } from 'common_util_node/util';
import { Kit, KitStatus } from './customerOverview';
import { APIError } from '../helpers/types';

export type GeneratedBarcode = {
  kitId: string;
  barcode: string;
  status: 'ordered';
  scope: ProductName[];
  history: KitHistoryRecord[];
  channel: SalesChannel[];
  segment: BarcodeSegment[];
};

type KitHistoryRecord = {
  status: string;
  datetime: string;
};

export enum ProductName {
  Health = 'global-health',
  HealthPlus = 'global-health-plus',
  FamilyPlanning = 'global-family-planning',
  Vital = 'global-vital',
  Premium = 'global-premium',
  UkFamilyPlanning = 'uk-family-planning',
  UkHealth = 'uk-health',
  UkVital = 'uk-vital',
  UkPremium = 'uk-premium',
  Genestart = 'hk-herbalife-genestart',
  ONEdnaScreen = 'onedna-screen',
  ONEdnaScreenDigital = 'onedna-screen-digital',
  ONEdnaPlusScreen = 'onedna-plus-screen',
  CircleCancer = 'circle-cancer',
  ColoClear = 'hk-coloclear',
}

export function isValidProductName(str: string | ProductName): str is ProductName {
  return arrayFromEnumValues(ProductName).includes(str as ProductName);
}

export enum SalesChannel {
  BdMarketing = 'bd-marketing',
  Consignment = 'consignment',
  D2C = 'd2c',
  B2B = 'b2b',
  IntercompanySales = 'intercompany-sales',
  Herbalife = 'herbalife',
  Watsons = 'watsons',
  Hsbc = 'hsbc',
  Testing = 'testing',
}

export enum BarcodeSegment {
  Fedex = 'fedex',
  SF = 'sf',
  Offline = 'offline',
  HerbalifeHk = 'herbalife-hk',
  HsbcHk = 'hsbc-hk',
  PwcHk = 'pwc-hk',
  WatsonsHk = 'watsons-hk',
  WatsonsSg = 'watsons-sg',
  InternalPrenetics = 'internal-prenetics',
  InternalDnafit = 'internal-dnafit',
}

export interface BarcodesState {
  loading: boolean;
  data: {
    kits: Kit[];
    total: number;
  };
  kitStatusFilter: KitStatus | undefined;
  searchTerm: string;
  currentPage: number;
}

export interface BarcodesPayload {
  kits: Kit[];
  total: number;
}
export interface GetBarcodeFormPayload {
  barcode: string;
}

export interface BaseModel {
  error?: APIError;
}
export interface Barcode extends BaseModel {
  kitId: string;
  status: BarcodeKitStatus;
  barcode?: string;
}

export enum BarcodeKitStatus {
  OPEN = 'open',
  ORDERED = 'ordered',
  ACTIVATED = 'activated',
  LAB = 'lab',
  READY = 'ready', // Sample received in lab
  REPORT_READY = 'report-ready',
}

export type KitValidationResponse = KitResponse[];
export type KitResponse = {
  kitId: string,
  datetime: string,
  barcode: string,
  status: BarcodeKitStatus,
  partner: string,
  error?: APIError,
};